import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "";

  const heroImages = [
    "/images/slider1.jpeg",
    "/images/slider2.jpeg",
    "/images/slider3.jpeg",
    
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  // ===== Leader Data =====
  const sarpanch = {
    name: "सौ. शालिनी मिलिंद मेश्राम ",
    phone: 8180829537,
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री. भीमराव धोंडबाजी डोंगरे ",
    photo: "/images/upsarpanch.jpeg",
  };

  const sachiv = {
    name: " शौ. देवयानी ठोंबरे",
    photo: "/images/sachiv.jpeg",
  };

  const members = [
    { sr: 1, name: "सौ.कविता कैलास रंगारी", ward: "सदस्य", phone: "8329769426" },
    { sr: 2, name: "श्री. यागेश सखाराम इंगळे", ward: "सदस्य", phone: "9823425631 " },
    { sr: 3, name: "श्री. संदीप माधो शामकुवर", ward: "सदस्य", phone: "8329851681" },
    { sr: 4, name: "सौ. माधुरी चंद्रभान गायकवाड ", ward: "सदस्य", phone: "9689473593" },
    { sr: 5, name: "सौ. वंदना गजानन मेश्राम ", ward: "सदस्य", phone: "79723 03268" },
    { sr: 6, name: "सौ. मंगला हरिदास खेळकर", ward: "सदस्य", phone: "9921681063" },


    { sr: 7, name: "श्री. शेषराव रामदास गेडाम", ward: "ग्राम पंचायत कर्मचारी", phone: "9271813525" },
    { sr: 8, name: " श्री. बाबा शंकर राऊत", ward: "संगणक परिचालक", phone: "9764597736" },
     
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* ===== Marquee ===== */}
      <div className="marquee-wrapper">
        <div className="marquee">
          ग्रामपंचायत ठोंबरा | पंचायत समिती उमरेड, जि. नागपूर | संपर्क:- 8180829537
        </div>
      </div>

      {/* ===== Hero Section ===== */}
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>ग्रामपंचायत "ठोंबरा" आपले स्वागत आहे {villageName}</h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
            <a href="/aboutus">अधिक माहिती</a>
          </div>
        </div>
      </section>

      {/* ===== Leaders Section ===== */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">
          {/* Leaders Cards */}
          <div className="leaders">
            {/* सरपंच */}
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
            </div>

            {/* उपसरपंच */}
            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
            </div>

            {/* सचिव */}
            <div className="leader-card sachiv-card">
              <div className="leader-img">
                <SafeImage src={sachiv.photo} alt="सचिव" />
              </div>
              <h3>ग्रामपंचायत अधिकारी</h3>
              <b>{sachiv.name}</b>
            </div>
          </div>

          {/* Members Table */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>पद</th>
                  <th>संपर्क</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                    <td>{m.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ===== Map Section ===== */}
<section className="map-section">
  <h2 className="map-title">📍 ग्रामपंचायत ठोंबरा – स्थान</h2>
  <p className="map-subtitle">
    ग्रामपंचायत ठोंबरा, तालुका उमरेड, जिल्हा नागपूर
  </p>

  <div className="map-container">
    <iframe
      title="Thombra Location"
      src="https://www.google.com/maps?q=20.8965196,79.3138108&z=17&output=embed"
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
  </div>
</section>
    </div>
  );
};

export default Home;